import TextAreaField from 'components/forms/textAreaField/TextAreaField';
import { useTranslation } from 'react-i18next';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import {
  IconContainer,
  LabelContainer,
} from '../SeasonalRuleAddEditModal.styles';

const HostfullyPolicyField = () => {
  const { t } = useTranslation();

  return (
    <TextAreaField
      label={
        <LabelContainer>
          <IconContainer>
            <HostfullyIcon data-testid="hostfully-icon" />
          </IconContainer>
          {t('pageProperty.seasonality.modal.fields.hostfullyPolicy.label')}
        </LabelContainer>
      }
      labelOnTop
      name="policies.hostfullyText"
      placeholder={t(
        'pageProperty.seasonality.modal.fields.hostfullyPolicy.placeholder',
      )}
      maxCharacters={1000}
      colSmLabel={12}
      colSmInput={12}
      rows={5}
    />
  );
};

export default HostfullyPolicyField;
